import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { push } from 'connected-react-router';
import { useParams } from 'react-router-dom';
import { Loader } from '../../../components/loader/Loader';
import { getErrorMessageKey, isSupportedLocale, LanguageType } from '../../../locale/locale';
import '../partnerLanding/PartnerLanding.css';
import { initializeAssistanceRequest } from './assistanceRequestPartnerActions';
import { getServiceThemeDataByAssistanceRequestId } from '../../../common/theme/themeActions';
import { useAssistanceRequestPartnerInitialization } from './useAssistanceRequestPartnerInitialization';
import { Translate } from 'react-redux-i18n';
import { getParamFromUrl } from '../../../common/utils/URLUtils';

interface PathParameters {
  serviceLinkName: string;
}

export const AssistanceRequestPartnerLanding: React.FC<AssistanceRequestPartnerLandingProps> = ({
  navigateToNextStep,
  initializeAssistanceRequest,
  getServiceThemeDataByAssistanceRequestId,
}: AssistanceRequestPartnerLandingProps) => {
  const language = getParamFromUrl('language');
  const { serviceLinkName } = useParams<PathParameters>();
  const { isFetching, data, error } = useAssistanceRequestPartnerInitialization(
    serviceLinkName,
    isSupportedLocale(language) ? (language as LanguageType) : undefined
  );

  if (isFetching) {
    return <Loader />;
  }
  if (error) {
    return (
      <div className='d-flex justify-content-center'>
        <p className='vertical-center'>
          {<Translate value={getErrorMessageKey((error as Error).message)} />}
        </p>
      </div>
    );
  }
  if (data) {
    initializeAssistanceRequest(data);
    getServiceThemeDataByAssistanceRequestId(data.assistanceRequestId).then(() =>
      navigateToNextStep(data.assistanceRequestExternalId)
    );
  }
  return <div />;
};

const mapDispatchToProps = {
  initializeAssistanceRequest,
  getServiceThemeDataByAssistanceRequestId,
  navigateToNextStep: (code: string) => push(`/assistance-request-link/${code}`),
};

export type AssistanceRequestPartnerLandingProps = ResolveThunks<typeof mapDispatchToProps>;

export default connect(null, mapDispatchToProps)(AssistanceRequestPartnerLanding);
